import React from 'react'
import StandBy from '../../components/common/StandBy'

function ProductosInfo() {
  return (
     <StandBy />
  )
}

export default ProductosInfo